import { Component, OnDestroy } from "@angular/core";
import { LocalstorageService, UserService } from "./shared";
import { Subscription } from "rxjs";
import { MenuService } from "./modules/master/services/menu.service";

@Component({
	selector: "body",
	host: {
		"[class.gray-bg]": "isLogin",
	},
	templateUrl: "./app.component.html",
})
export class AppComponent implements OnDestroy {
	isLogin: Boolean = true;
	subscription: Subscription;

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscription.unsubscribe();
	}

	constructor(private userService: UserService, private menuService: MenuService, private localService: LocalstorageService) {
		this.subscription = this.menuService.CheckMenuList().subscribe((response) => {
			this.localService.setItem("lstRouterLinks", response.lstRouterLink);

			setTimeout(() => {
				this.isLogin = !response.isloaded;
			});
		});
	}
}
